/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const GET_USER_NOTIFICATION_PREFERENCES = gql`
  query GetUserNotificationPreferences {
    userNotificationPreferences {
      blockedChannels
    }
  }
`
